import React, { useState, useEffect, useMemo } from 'react';
import styles from './ConvertPositionModal.module.css';
import * as api from '../utils/api';
import { FiInfo, FiRefreshCw } from 'react-icons/fi';

const ConvertPositionModal = ({ isOpen, onClose, position, onConvert, livePrice }) => {
  const [availableMargin, setAvailableMargin] = useState(0);

  useEffect(() => {
    if (isOpen) {
      const fetchUser = async () => {
        try {
          const res = await api.getUser();
          setAvailableMargin(res.data.fund);
        } catch (err) {
          console.error(err);
        }
      };
      fetchUser();
    }
  }, [isOpen]);

  const additionalMarginNeeded = useMemo(() => {
    if (!position || !livePrice) return 0;
    const currentMarginUsed = (livePrice * position.quantity) / (position.margin || 1);
    const fullMargin = livePrice * position.quantity;
    return Math.max(0, fullMargin - currentMarginUsed);
  }, [livePrice, position]);

  const insufficientFunds = additionalMarginNeeded > availableMargin;

  if (!isOpen || !position) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onConvert(position._id);
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <div className={styles.iconCircle}>
            <FiRefreshCw />
          </div>
          <h3>Convert Position</h3>
          <p>{position.tradeSymbol}</p>
        </div>

        <div className={styles.infoBox}>
          <p>Converting to <strong>Carryforward (CNC)</strong> will require full margin. Intraday leverage will be removed.</p>
        </div>

        <div className={styles.marginStats}>
          <div className={styles.statRow}>
            <span>Available Funds</span>
            <span>₹{availableMargin.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
          </div>
          <div className={styles.statRow}>
            <span>Additional Margin Needed</span>
            <span className={styles.highlight}>₹{additionalMarginNeeded.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
          </div>
        </div>

        {insufficientFunds && (
          <div className={styles.warning}>
            <FiInfo />
            <span>Insufficient funds to convert this position.</span>
          </div>
        )}

        <div className={styles.actions}>
          <button className={styles.btnCancel} onClick={onClose}>Cancel</button>
          <button 
            className={styles.btnConfirm} 
            onClick={handleSubmit}
            disabled={insufficientFunds}
          >
            Confirm Conversion
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConvertPositionModal;
